import { Children, useState } from 'react';
import styles from './pestanyes.module.scss';
import clsx from 'clsx';

const Pestanya = ({ children }) => children;

const Pestanyes = ({ children, estil }) => {
    const pestanyes = Children.toArray(children).filter(Boolean);
    const indexInicialActiu = pestanyes.findIndex((pestanya) => pestanya?.props?.activa);
    const [indexActiu, setIndexActiu] = useState(indexInicialActiu >= 0 ? indexInicialActiu : 0);

    const stylesPestanyes = clsx({
        //[styles.pestanyesWrapper]: true,
        [styles[estil]]: !!estil
    });

    return (
        <div className={stylesPestanyes}>
            <div role='tablist' aria-label='Pestanyes' className={styles.pestanyes}>
                {pestanyes.map((pestanya, index) => {
                    const activa = index === indexActiu;

                    return (
                        <button
                            key={`${pestanya?.props?.titol || 'pestanya'}-${index}`}
                            type='button'
                            role='tab'
                            aria-selected={activa}
                            className={clsx(styles.pestanya, { [styles.active]: activa })}
                            onClick={() => setIndexActiu(index)}
                        >
                            {pestanya?.props?.titol}
                        </button>
                    );
                })}
            </div>
            <div role='tabpanel' className={styles.contingut}>
                {pestanyes[indexActiu]}
            </div>
        </div>
    );
};

export { Pestanyes, Pestanya };
